import { render } from "./ObjectviewWidget.vue?vue&type=template&id=3930e548"
import script from "./ObjectviewWidget.vue?vue&type=script&lang=js"
export * from "./ObjectviewWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__